<script>
/* eslint-disable */
import OffRamp from '../components/OffRamp.vue';

export default {
  name: 'PrivacyPolicy',
  components: {
    OffRamp,
  },
  data() {
    return {
      offRampActive: false,
      link: '',
    };
  },
  methods: {
    showOffRamp(link) {
      this.link = link;
      this.offRampActive = true;
    },
  },
};
</script>

<template>
  <div class="grid-container fluid">
    <OffRamp
      :link="link"
      @closeOffRamp="offRampActive = false"
      v-if="offRampActive === true" />
    <div class="bg-lg grid-x grid-padding-x">
      <div class="cell small-12 medium-8 medium-offset-2">
          <img class="logo" width="100" src="../../public/img/EQRx-Logo.svg" alt="EQRx" />
          <h1>Privacy Policy</h1>
          <span class="white-space show-for-medium">&nbsp;</span>
      </div>
    </div>
    <div class="grid-x grid-padding-x">
      <div class="cell small-12 medium-8 medium-offset-2">
        <h2>Our policy</h2>
        <p>
          Welcome to the Privacy Policy of EQRx International, Inc. (“Company”, “we”, “us” and/or “our”). This Privacy Policy is operated by the Company and has been created to provide information about the Company and its technology (together with the Privacy Policy, the “Technology”) to our users (“you”, “your”) of the data collection form (the "Form"). This Privacy Policy sets forth the Company's policy with respect to the information it collects about you via the Form that identifies you or can be used to identify you (“Personal Data”).
        </p>
        <h2>Personal Data We Collect:</h2>
        <p>
          We collect Personal Data from you when you interact through the Form, as further described below. Personal Data includes:
        </p>
        <ul>
          <li>Identifiers, such as your name and email address;</li>
          <li>Demographic information about you.</li>
        </ul>
        <h2>Personal Data That You Provide Through the Form:</h2>
        <p>
          We collect Personal Data from you when you voluntarily provide such information by filling out and submitting this Form. Wherever the Company collects Personal Data we make an effort to provide a link to this Privacy Policy.
        </p>
        <p>
          In addition, from time to time, we may use or augment the Personal Data we have about you with information obtained from other sources, such as public databases, social media platforms, and other third parties.
        </p>
        <h2>
          The Company's Use of Your Personal Data:
        </h2>
        <p>
          The Company uses the Personal Data you provide in a manner that is consistent with this Privacy Policy. If you provide Personal Data for a certain reason, we may use the Personal Data in connection with the reason for which it was provided. For instance, if you contact us by email, we will use the Personal Data you provide to answer your question or resolve your problem. By communicating with us, to the extent required or permitted by applicable law, you consent to receive electronic communications, including emails and other marketing communications. If we send such communications, each marketing communication will contain instructions permitting you to “opt-out” of receiving future marketing communications. In addition, if at any time you wish not to receive any future marketing communications or you wish to have your name deleted from our mailing lists, please contact us as indicated below.
        </p>
        <h2>
          Aggregated and/or De-Identified Data:
        </h2>
        <p>
          In an ongoing effort to better understand and serve the users of the Form, the Company may conduct research on its customers' demographics, interests, and behavior based on the Personal Data provided to us. The Company reserves the right to aggregate and/or de-identify Personal Data it collects to create information that does not identify any individual, and use that information for the above-listed purposes and other business purposes.
        </p>
        <p>
          If the Company intends on using any Personal Data in any manner that is not consistent with this Privacy Policy, you will be informed of such anticipated use prior to or at the time at which the Personal Data is collected.
        </p>
        <h2>
          Disclosure of Your Personal Data:
        </h2>
        <p>
          The Company is not in the business of selling your information. We consider this information to be a vital part of our relationship with you. There are, however, certain circumstances in which we may share your Personal Data with certain third parties without further notice to you, as set forth below:
        </p>
        <h3>
          Business Transfers:
        </h3>
        <p>
          As we develop our business, we might sell or buy businesses or assets. In the event of a corporate sale, merger, reorganization, dissolution or similar event, Personal Data may be part of the transferred assets.
        </p>
        <h3>
          Related Companies:
        </h3>
        <p>
          We may also share your Personal Data with our Related Companies for purposes consistent with this Privacy Policy.
        </p>
        <h3>
          Agents, Consultants and Related Third Parties:
        </h3>
        <p>
          The Company, like many businesses, sometimes hires other companies to perform certain business-related functions. Examples of such functions include mailing information, maintaining databases, and processing payments. When we employ another entity to perform a function of this nature, we only provide them with the information that they need to perform their specific function.
        </p>
        <h3>
          Legal Requirements:
        </h3>
        <p>
          The Company may disclose your Personal Data if required to do so by law or in the good faith belief that such action is necessary to (i) comply with a legal obligation, (ii) protect and defend the rights or property of the Company, (iii) act in urgent circumstances to protect the personal safety of users of the Form or the public, or (iv) protect against legal liability.
        </p>
        <h3>
          Aggregated and/or De-Identified Information:
        </h3>
        <p>
          The Company reserves the right to share aggregated and/or de-identified data with third parties for any purpose.
        </p>
        <h2>
          Storage of Personal Data:
        </h2>
        <p>
          The Company may store Personal Data itself or such information may be included in databases owned and maintained by Related Companies, agents, or service providers. The Company may store Personal Data for different periods of time depending on the category of information.
        </p>
        <p>
          Some information might be deleted automatically based on specific schedules, such as marketing information. Other Personal Data might be retained for a longer period of time based on the contract individuals have with the Company. We might also retain information for business practices based on our legitimate interest or legal purposes, such as network improvement, fraud prevention, record-keeping, or enforcing the Company’s legal rights.
        </p>
        <h2>
          Security:
        </h2>
        <p>
          The Company takes reasonable steps to protect the Personal Data collected via the Form from loss, misuse, and unauthorized access, disclosure, alteration, or destruction. However, no Internet or email transmission is ever fully secure. In particular, email sent to or from us may not be secure. Therefore, you should take special care in deciding what information you provide to us. Please keep this in mind when disclosing any Personal Data to Company via the Internet or through the Form.
        </p>
        <h2>
          Changes to the Company's Privacy Policy:
        </h2>
        <p>
          The Data Collection Form and the Company's business may change from time to time. As a result, at times it may be necessary for the Company to make changes to this Privacy Policy. The Company reserves the right to update or modify this Privacy Policy at any time and from time to time without prior notice. Please review this Privacy Policy and the Form periodically. This Privacy Policy was last updated on the date indicated above. Your continued use of the Form after any changes or revisions to this Privacy Policy shall indicate your agreement with the terms of such revised Privacy Policy. If you do not agree to this Privacy Policy, please do not use the Form.
        </p>
        <h2>
          Other Terms and Conditions:
        </h2>
        <p>
          Your access to and use of the Data Collection Form is subject to the <router-link to="/terms-conditions">Terms of Use</router-link>
        </p>
        <h2>
          Users in the European Economic Area and the United Kingdom:
        </h2>
        <p>
          If you are located in the European Economic Area (“EEA”) or the United Kingdom (“UK”), your Personal Data may be protected by data protection laws in the EEA or UK, such as the European Union General Data Protection Regulation (“GDPR”), the UK Data Protection Act 2018 and the UK GDPR (for purposes of this Privacy Policy, these laws are referred to collectively as the “GDPR”). The Company will comply with the GDPR when using, sharing and otherwise processing your Personal Data as described in this Privacy Policy.
        </p>
        <p>
          You may be requested to provide some or all of the Personal Data described in this Privacy Policy in connection with your use of the Form. If you fail to provide certain information when requested, and this Personal Data is necessary for the Company to comply with its legal and regulatory obligations, to perform the contract it has entered into with you, or to manage its relationship with you, the Company and/or the Related Companies will not be able to continue your involvement with the Form. In all other cases the provision of your Personal Data is voluntary.
        </p>
        <p>
          Under the GDPR, the Company and/or the Related Companies rely on one or more of the following legal bases for processing your Personal Data.
        </p>
        <h3>
          Where the Company needs to perform the contract or services agreement it is about to enter into or have entered into with you, including for the following purposes:
        </h3>
        <ul>
          <li>
            Registering you as a new user of the Form and providing services to you; and
          </li>
          <li>
            Sending you information about changes to its policies, terms of service and other relevant documentation relating to Company and the Form.
          </li>
        </ul>
        <h3>
          Where it is necessary for the Company's legitimate interests (or those of a third party) and where consistent with applicable laws:
        </h3>
        <ul>
          <li>
            Arranging insurance; operating and planning its business; managing its intellectual property, equipment and facilities; and investigating any complaints received from you or from others;
          </li>
          <li>
            Providing you with access to content and features in the Form; and
          </li>
          <li>
            Protecting the Company's, your, and others' rights, privacy, safety or property; investigating and deterring against fraudulent, harmful, unauthorized, unethical or illegal activity; and answer your data protection requests.
          </li>
        </ul>
        <h3>
          Where the Company needs to comply with a legal or regulatory obligation:
        </h3>
        <ul>
          <li>
            Administering and protecting its business, including troubleshooting, data analysis, testing, system, maintenance and support, reporting and hosting data;
          </li>
          <li>
            Regulatory record-keeping and reporting obligations, including those relating to complaints and product safety; and
          </li>
          <li>
            In response to requests from government law enforcement authorities conducting an investigation.
          </li>
        </ul>
        <h3>
          Where you have given your consent:
        </h3>
        <ul>
          <li>
            Delivering relevant content and advertisements to you and measuring and understanding the effectiveness of the advertising the Company and its partners serve to you;
          </li>
          <li>
            Using cookies and data analytics to improve its products and services, marketing, customer relationships and experiences; and
          </li>
          <li>
            Making suggestions and recommendations to you about goods or services that may be of interest to you.
          </li>
        </ul>
        <p>
          Under the GDPR, you may have specific rights, including the rights to:
        </p>
        <ul>
          <li>
            Ask us for a copy of your Personal Data;
          </li>
          <li>
            Request that we rectify Personal Data you think is inaccurate or complete information you think is incomplete;
          </li>
          <li>
            Request that we erase your Personal Data in certain circumstances;
          </li>
          <li>
            Request that we restrict the processing of your Personal Data in certain circumstances;
          </li>
          <li>
            Object to the processing of your Personal Data in certain circumstances; and
          </li>
          <li>
            Request that we transfer the Personal Data you gave us to another organization, or to you, in certain circumstances.
          </li>
        </ul>
        <p>
          You can make a request by contacting us using the contact information at the end of this Privacy Policy.
        </p>
        <p>
          The Company is headquartered in the United States and, as a result, your Personal Data will be processed by the Company in the U.S. The Company may contract with service providers to process your Personal Data on Company’s behalf, and these service providers may also be located outside of the EEA and UK. Data protection laws in the U.S. or other countries may not offer you the same protections as the laws of the country in which you are residing when your Personal Data is collected. To the extent required, the Company will ensure that such transfer and processing of your Personal Data is conducted in accordance with the GDPR.
        </p>
        <p>
          If you are in the EEA and have a request or question about the Company's privacy practices, you can also contact its EEA Data Protection Representative:
        </p>
        <p>
          Attn: Guidehouse Life Sciences GRC
        </p>
        <p>
          Address: Guidehouse Germany GmbH, Albrechtstrasse 10c, 10117 Berlin, Germany
        </p>
        <p>
          Email: <a class="text-red" href="mailto:eudpr@EQRx.com">eudpr@EQRx.com</a>
        </p>
        <p>
          If you are in the UK and have a request or question about the Company's privacy practices, you can also contact its UK Data Protection Representative:
        </p>
        <p>
          Attn: Guidehouse Life Sciences GRC
        </p>
        <p>
          Address: Guidehouse Europe Limited, 1 Angel Court, London EC2R 7HJ, United Kingdom
        </p>
        <p>
          Email: <a class="text-red" href="mailto:ukdpr@EQRx.com">ukdpr@EQRx.com</a>
        </p>
        <p>
          If you have any concerns about our use of your Personal Data, you can make a complaint at the same addresses. If you are in the UK, you can also complain to the Data Protection Authority of the UK (the ICO), using this <span @click="showOffRamp('https://ico.org.uk/make-a-complaint/')" class="text-red link">webform</span> if you are unhappy with how the Company has used your Personal Data. If you are in the EEA, you can complain to the National Data Protection Authority of the place where you live, work or where you consider that a violation of the GDPR took place. More information can be found on this <span @click="showOffRamp('https://edpb.europa.eu/about-edpb/about-edpb/members_en')" class="text-red link">website</span>.
        </p>
        <h2>
          Access to Information; Contacting Company:
        </h2>
        <p>
          To keep your Personal Data accurate, current, and complete, please contact us as specified below. We will take reasonable steps to update or correct Personal Data in our possession that you have previously submitted via the Form. Please also feel free to contact us if you have any questions about the Company's Privacy Policy or the information practices of the Form.
        </p>
        <h3>
          You may contact us as follows:
        </h3>
        <h4>
          By mail:
        </h4>
        <p>
          EQRx International, Inc.
        </p>
        <p>
          50 Hampshire Street
        </p>
        <p>
          Cambridge, MA 02139
        </p>
        <p>
          Attn: EQRx webmaster
        </p>
        <h4>
          By Email:
        </h4>
        <p>
          <a class="text-red" href="mailto:privacy@EQRx.com">privacy@EQRx.com</a> with subject line: eqrx.com Personal Data Request
        </p>
      </div>
    </div>
    <footer>
      <div class="red-ball show-for-medium">&nbsp;</div>
      <div class="grid-x grid-padding-x">
        <div class="preparation cell small-12 medium-8 medium-offset-2 large-4 large-offset-4">
          <p>
            The EQRx logo and other trademarks or service marks of EQRx appearing in this
            communication are the property of EQRx.
          </p>
          <p class="code">MAT-NP-0012</p>
          <p class="date">Date of Preparation: April 2023</p>
        </div>
      </div>
    </footer>
  </div>
</template>
